import { jsx as _jsx } from "react/jsx-runtime";
import { PlayerControlButtonComponent } from "./PlayerControlButton";
const IconButton = ({ onClick, hoverText, label, hidden, gridArea, Icon, interactive, forceBottom, forceLeft, }) => {
    return (_jsx(PlayerControlButtonComponent, { "aria-label": label, style: {
            gridArea: gridArea ?? undefined,
        }, onClick: onClick, hidden: hidden, interactive: interactive, hoverText: hoverText, Icon: Icon, forceBottom: forceBottom, forceLeft: forceLeft }));
};
export default IconButton;
